import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";
import { e2eEncrypt } from "@/libs/crypto-js";

const resource = `${Config.basePath}/chat/message`;

export default {
  index(payload) {
    return Client.post(`${resource}/list`, {
      data: e2eEncrypt(JSON.stringify(payload)),
    });
  },
  latest(payload) {
    return Client.post(`${resource}/latest`, {
      data: e2eEncrypt(JSON.stringify(payload)),
    });
  },
  seen(payload) {
    return Client.post(`${resource}/seen`, {
      data: e2eEncrypt(JSON.stringify(payload)),
    });
  },
  typing(payload) {
    return Client.post(`${resource}/typing`, {
      data: e2eEncrypt(JSON.stringify(payload)),
    });
  },
  create(payload) {
    return Client.post(`${resource}/create`, {
      data: e2eEncrypt(JSON.stringify(payload)),
    });
  },
  delete(id) {
    return Client.delete(`${resource}/${id}`);
  },
  transcribe(id) {
    return Client.post(`${resource}/transcribe/${id}`);
  },
  getAttachments(chatChannelId) {
    return Client.get(`${resource}/attachments/${chatChannelId}`);
  },
};
